import React from 'react';
import { Box } from '@mui/material';
import { DashboardLayout } from '@components/layout/DashboardLayout.tsx';
import { PageHint } from '@components/common/PageHint.tsx';
import { AdminPromptsTab } from '@components/admin/AdminPromptsTab.tsx';
import { PageIndices } from '@/common/i-doc/i-doc.registry';

/**
 * Системні промпти (2026-09-30) - окрема сторінка замість вкладки "Промпти" в системних налаштуваннях: промпти мають
 * власний API (`/admin/system-prompts`), ролі, зберігання й журнал змін, і їх більшатиме. Старе посилання
 * `/admin/system-settings?tab=prompts` перенаправляє сюди.
 */
export const AdminSystemPromptsPage: React.FC = () => (
  <DashboardLayout>
    <Box data-i-doc={PageIndices.ADMIN_SYSTEM_PROMPTS}>
      <PageHint iDoc={PageIndices.ADMIN_SYSTEM_PROMPTS} />
      <AdminPromptsTab />
    </Box>
  </DashboardLayout>
);
